import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Carousel from 'nuka-carousel';
import cn from 'classnames';

import LandingPageImage from 'components/landing/LandingPageImage';
import css from 'styles/components/landing/heroFancy.scss';

const xPositionMap = {
  left: css.left,
  center: css.centerX,
  right: css.right
};

const yPositionMap = {
  top: css.top,
  center: css.centerY,
  bottom: css.bottom
};

const textAlignMap = {
  left: css.alignLeft,
  center: css.alignCenter,
  right: css.alignRight
};

const carouselDecorators = [
  {
    position: 'BottomCenter',
    component: ({ slideCount, currentSlide, goToSlide }) => {
      const dots = [];
      for (let i = 0; i < slideCount; i++) {
        dots.push(
          <li key={i}>
            <button type="button" onClick={() => goToSlide(i)} className={cn({ [css.activeDot]: i === currentSlide })}>
              Go to slide {i + 1}
            </button>
          </li>
        );
      }
      return (
        <ul className={css.sliderDots}>
          {dots}
        </ul>
      );
    }
  }
];

const makeHero = (item, slotName, onLandingComponentClick) => {
  const {
    cta,
    ctatype,
    align,
    heading,
    link,
    subheading,
    transparent,
    translucent,
    xaxis,
    yaxis,
    contentwidth,
    src,
    mobilesrc,
    tabletsrc,
    retina,
    mobileretina,
    tabletretina,
    alt
  } = item;
  const imageProps = { src, mobilesrc, tabletsrc, retina, mobileretina, tabletretina, alt, shouldLazyLoad: true };
  return (
    <div
      className={css.hero}
      key={src || link || heading || cta}>
      <LandingPageImage {...imageProps} />
      {(heading || subheading || cta || link) &&
        <div
          className={cn(
            css.content,
            { [xPositionMap[xaxis] || '']: xaxis },
            { [yPositionMap[yaxis] || '']: yaxis },
            { [textAlignMap[align] || '']: align },
            { [css.transparent]: transparent === 'true' },
            { [css.translucent]: translucent === 'true' }
          )}
          style={{ width: contentwidth }}>
          {heading && <h2>{heading}</h2>}
          {subheading && <p className={css.subheading}>{subheading}</p>}
          {link && cta &&
            <Link
              onClick={onLandingComponentClick}
              href={link}
              className={cn(
                { [css.cta]: !ctatype },// default w/ no specified type
                { [css.arrowRight]: ctatype === 'arrowright' },
                { [css.arrowLeft]: ctatype === 'arrowleft' }
              )}>
              {cta}
            </Link>
          }
        </div>
      }
    </div>
  );
};

const HeroFancy = ({ slotName, slotDetails: { hero, split, fullscreen, slider, monetateId }, onLandingComponentClick }) => {

  let contents = hero && hero.map(v => makeHero(v, slotName, onLandingComponentClick));

  if (slider === 'true') {
    // Using nuka 3.2  https://www.npmjs.com/package/nuka-carousel/v/3.2.0
    contents = (
      <Carousel
        decorators={carouselDecorators}
        autoplay={true}
        autoplayInterval={5000}
        pauseOnHover={true}
        dragging={true}
        swiping={true}
        wrapAround={true}>
        {contents}
      </Carousel>
    );
  }

  return (
    <div
      className={cn(css.container,
        { [css.split]: split === 'true' },
        { [css.fullScreen]: fullscreen === 'true' })}
      data-slot-id={slotName}
      data-monetate-id={monetateId}>
      {contents}
    </div>
  );
};

HeroFancy.contextTypes = {
  testId: PropTypes.func
};

export default HeroFancy;
